import React from "react";
import PropTypes from "prop-types";
import { NavLink as RouteNavLink } from "react-router-dom";
import { NavItem, NavLink } from "shards-react";
import { Dispatcher, Constants } from "../../../flux";

const SidebarNavItem = ({ item }) => (
  <NavItem>
    <NavLink className = {`step-${item.to.replace('/','')}`} tag={RouteNavLink} to={item.to} onClick={()=>{
 Dispatcher.dispatch({
  actionType: Constants.TOGGLE_SIDEBAR
});
}}>
      {item.htmlBefore && (
        <div
          className="d-inline-block item-icon-wrapper"
          dangerouslySetInnerHTML={{ __html: item.htmlBefore }}
        />
      )}
      {item.title && <span>{item.title}</span>}
      {item.htmlAfter && (
        <div
          className="d-inline-block item-icon-wrapper"
          dangerouslySetInnerHTML={{ __html: item.htmlAfter }}
        />
      )}
    </NavLink>
  </NavItem>
);

SidebarNavItem.propTypes = {
  /**
   * The item object.
   */
  item: PropTypes.object
};

export default SidebarNavItem;
